<template>
  <div class="content-center none-click introduce">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/introduction_banner.png" alt="">
    </div>
    <div class="introdution">
      <div class="title">公司介绍</div>
      <p class="paragraph">
        汇通数科智能科技有限公司 (简称汇通数科) 是中国领先的商业智能数字化技术与数字化运营服务商，<strong>2019年成立于</strong>江苏省南京市，深耕产业数字化、数字营销,是一家<strong>人工智能科技公司</strong>。由汇通达网络股份有限公司(股票代码: 9878.HK) 投资控股。</p>
      <p class="paragraph">
        以“<strong>AI+RPA</strong>”为技术基础，为<strong>品牌商、零售商</strong>提供智慧分销、智慧零售、智慧门店<strong>等场景化技术解决方案</strong>以及<strong>终端营销与管理、金融科技等商家解决方案服务</strong>，让生意更简单。
      </p>
      <p class="paragraph">
        公司技术研发人员、数字营销人员超百人，且拥有丰富的行业经验。
      </p>
      <p class="paragraph">
        截至2022年底，公司已服务超11万家终端零售客户150多家企业级客户。
      </p>
      <div class="imgWrap">
        <img src="@/assets/Mobile/images/solution/introduction_htsk.png" alt="">
      </div>
      <p class="paragraph">
        汇通数科作为数字化企业践行者，坚持人工智能科技创新与数据驱动客户持续成长。截至目前，拥有专利2项、软著100项+、商标100项+，荣获“国家级高新技术企业”、“江苏省软件企业”、“江苏省科技中小企业”、“南京市瞪羚企业”等数十多项殊荣，成功认定“南京市工程技术研究中心”、“中国产业互联网技术赋能先锋奖”、“数字服务创新”企业；产品及服务通过“AAA级信用企业”、ISO9001、ISO14001、ISO45001、ISO27001质量管理体系认证等。
      </p>
    </div>
    <div class="introduction">
        <img src="@/assets/Mobile/images/solution/programme.png" alt="">
        <div class="title">公司使命</div>
        <p class="introduction_text"><span class="text_color">技术</span>驱动品牌商、零售商全场景<span class="text_color">数字化升级</span>，提供一站式解决方案服务助力<span class="text_color">经营提效，让生意更简单</span></p>
        <div class="title">公司愿景</div>
        <p class="introduction_text">持续提升全链路<span class="text_color">人工智能</span>服务水平，用数字技术和一站式解决方案驱动<span class="text_color">产业增长</span></p>
        <div class="title">公司定位</div>
        <p class="introduction_text"><span class="text_color">“AI+RPA”</span>商业智能为核心的<span class="text_color">数字化技术与数字化运营服务商</span></p>
    </div>
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
export default {
  metaInfo: metaInfo.Introduce,
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.introduction{
    background: #F7F9FC;
    padding-bottom:20px;
    img{
        width: 325px;
        height:233px;
        margin-top:15px;
    }
    .title {
      font-size: 21px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      padding: 20px 0 9px;
      text-align: left;
      padding-left:15px;
    }
    .introduction_text{
        font-size: 12px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 23px;
        padding:0 15px 0px 15px;
        text-align: left;
        .text_color{
            color: #0053EF;
        }
    }
}
.introduce{
    background: #f0f2f5;
    
}
  .banner {
    margin-top: 50px;
    img {
      width: 375px;
      height: 200px;
    }
  }
  .introdution {
    width: 343px;
    margin: 0 auto;
    background: #f0f2f5;
    .title {
      font-size: 20px;
      font-weight: 600;
      color: #222222;
      line-height: 28px;
      padding: 20px 0 9px;
      text-align: center;
    }
    .paragraph {
      text-align: left;
      margin-bottom: 25px;
      font-size: 14px;
      color: #222222;
      line-height: 24px;
    }
    .imgWrap {
      img {
        width: 256px;
        height: 87px;
        margin: 20px auto;
      }
    }
  }
</style>
